// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationAfterLogin-headerNavSubListContainer-E0VZC {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 24px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.NavigationAfterLogin-headerMenuItem-NUoF5 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 4px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    color: var(--primary-foreground);
    padding: 0;
}

.NavigationAfterLogin-headerMenuItem-NUoF5:hover,
.NavigationAfterLogin-headerMenuItem-NUoF5:focus {
    color: var(--primary-foreground);
}

.NavigationAfterLogin-activeTabMenu-BIylU {
    color: var(--primary-link-foreground) !important;
}

@media (max-width: 1199px) {
    .NavigationAfterLogin-headerMenuItem-NUoF5 {
        width: 100%;
    }
}

/* Pending Large-Project quotes counter — small red pill next to "My Projects".
   Only rendered when the sum of receivedQuoteCount across the client's
   projects is > 0 ("quotes waiting" at a glance). */

.NavigationAfterLogin-navQuoteBadge-DVS0S {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 6px;
    margin-left: 6px;
    border-radius: 999px;
    background: #e8232b;
    color: #fff;
    font-size: 11px;
    font-weight: 800;
    line-height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigations/NavigationAfterLogin/NavigationAfterLogin.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,UAAU;AACd;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AACA;;oDAEoD;;AACpD;IACI,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".headerNavSubListContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    align-items: flex-start;\n}\n\n.headerMenuItem {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n    padding: 0;\n}\n\n.headerMenuItem:hover,\n.headerMenuItem:focus {\n    color: var(--primary-foreground);\n}\n\n.activeTabMenu {\n    color: var(--primary-link-foreground) !important;\n}\n\n@media (max-width: 1199px) {\n    .headerMenuItem {\n        width: 100%;\n    }\n}\n/* Pending Large-Project quotes counter — small red pill next to \"My Projects\".\n   Only rendered when the sum of receivedQuoteCount across the client's\n   projects is > 0 (\"quotes waiting\" at a glance). */\n.navQuoteBadge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 18px;\n    padding: 0 6px;\n    margin-left: 6px;\n    border-radius: 999px;\n    background: #e8232b;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 800;\n    line-height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerNavSubListContainer": `NavigationAfterLogin-headerNavSubListContainer-E0VZC`,
	"headerMenuItem": `NavigationAfterLogin-headerMenuItem-NUoF5`,
	"activeTabMenu": `NavigationAfterLogin-activeTabMenu-BIylU`,
	"navQuoteBadge": `NavigationAfterLogin-navQuoteBadge-DVS0S`
};
module.exports = ___CSS_LOADER_EXPORT___;
